export const job = `<div style="width: 100%;"><div style="
    height: 3.25rem;
    width: calc(100% + 8px);
    box-sizing: border-box;
    background-color: rgb(245, 247, 247);
    margin-left: -8px;
"></div>
<div style="position: sticky;top: 17px;height: 68px;z-index: 3;display: flex;border-bottom: 1px solid rgb(187, 187, 187);justify-content: space-between;background-color: rgb(255, 255, 255);width: 100%;">
</div>`;
